import { render, staticRenderFns } from "./parcel-filter.vue?vue&type=template&id=55be4e86"
import script from "./parcel-filter.vue?vue&type=script&lang=ts"
export * from "./parcel-filter.vue?vue&type=script&lang=ts"
import style0 from "./parcel-filter.vue?vue&type=style&index=0&id=55be4e86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports